/* eslint-disable @typescript-eslint/no-unused-vars */
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ApolloModule, APOLLO_OPTIONS } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { InMemoryCache, ApolloLink, DefaultOptions } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { environment } from 'src/environments/environment';
import { typeDefs, resolvers } from '../../mocks';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { extractFiles } from 'extract-files';
import { GraphQLErrorLinkService } from './graphql-error.link';

const uri = environment.apiUrl;

export function createApollo(httpLink: HttpLink, errorLinkService: GraphQLErrorLinkService) {
  const basic = setContext((operation, context) => ({
    headers: {
      Accept: 'charset=utf-8',
    },
  }));

  const link = ApolloLink.from([basic, errorLinkService.link, httpLink.create({ uri, extractFiles })]);
  const cache = new InMemoryCache();

  // disable cache by default
  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
    mutate: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  };

  return {
    link,
    cache,
    typeDefs,
    resolvers,
    defaultOptions,
  };
}

@NgModule({
  imports: [AuthModule.forRoot(environment.auth), ApolloModule],
  exports: [HttpClientModule],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHttpInterceptor,
      multi: true,
    },
    {
      provide: APOLLO_OPTIONS,
      useFactory: createApollo,
      deps: [HttpLink, GraphQLErrorLinkService],
    },
  ],
})
export class GraphQLModule {}
